// Base interface for all types of invites
import type { IEvaluationProject } from '../Project/IEvaluationProject.js'
import type { IOrganization, IUser } from '../User/IUser.js'
import type { ICustomerCreatedOrder } from '../Order/IOrder.js'

export interface IEmailNotification {
  type: 'project-invite' | 'lab-invite' | 'order-notification'
  id: number
  creatorId: string
  creatorOrg: string
  email: string
  userId?: string
  organizationId?: string
  additionalText: string
}

// Interface for project invites
export interface IProjectInvite extends IEmailNotification {
  type: 'project-invite'
  projectId: string
  mayEdit: boolean
  project: IEvaluationProject
  inviterUser: IUser
  projectOwner: IUser
  invitedUserEmail: string
}

// Interface for lab invites
export interface ILabInvite extends IEmailNotification {
  type: 'lab-invite'
  orderId: string
  order: ICustomerCreatedOrder
  inviterUser?: IUser
  invitedOrg?: IOrganization
  checksum: string
}

// Interface for order notifications
export interface IOrderCompletedNotification extends IEmailNotification {
  type: 'order-notification'
  orderId: string
  orderName: string
}

// Union type for all invite types
export type Invite = IProjectInvite | ILabInvite | IOrderCompletedNotification

// Container for lists of invites
export interface IInviteList {
  labInvites?: ILabInvite[]
  orderCompletedNotifications?: IOrderCompletedNotification[]
  projectInvites?: IProjectInvite[]
}

// Container for received and sent invites
export interface IInviteContainer {
  received: IInviteList
  send: IInviteList
}

export function isProjectInvite(invite: IEmailNotification): invite is IProjectInvite {
  return invite.type == 'project-invite'
}

export function isOrderCompletedNotification(invite: IEmailNotification): invite is IOrderCompletedNotification {
  return invite.type == 'order-notification'
}

export function isLabInvite(invite: IEmailNotification): invite is ILabInvite {
  return invite.type == 'lab-invite'
}
